import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  relationship_type?: number;
  source?: number;
  target?: number;
  percentage?: number;
  description?: string;
  from_date?: string;
  to_date?: string;
}

export const useAddProfile = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params[]) => {
    return axios.post(
      `${env.verifyServiceUrl}individual/edge/bulk/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
